'use strict';

class Logout {
  constructor($window, userService) {
    this.$window = $window;
    this.userService = userService;
  }

  process() {
    this.$window.sessionStorage.removeItem('originatorId');
    this.$window.location.href = '/';
  }

  logout() {
    this.userService.logout()
      .then(() => this.process())
      .catch(() => this.process());
  }
}

Logout.$inject = ['$window', 'userService'];

const logout = {
  controller: Logout,
  template: `
    <a href ng-click="$ctrl.logout()">Logg ut</a>
  `
};

angular
  .module('SendRegning')
  .component('logout', logout);
